import { _axios } from "../../../Utils/Axios/axios";
export const getUserInfoService = async (userToken: string) => {
  return _axios.post(
    "/profile",
    {},
    {
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
    }
  );
};
